exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app p:first-child { \n    margin-top: 0;\n}\n\n.app p:last-child { \n    margin-bottom: 0;\n}", ""]);

// exports
